import { render, staticRenderFns } from "./select-file.vue?vue&type=template&id=2984d246&scoped=true&"
import script from "./select-file.vue?vue&type=script&lang=js&"
export * from "./select-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984d246",
  null
  
)

export default component.exports